import React, { useEffect } from 'react';

const SquareCategoriesSlider = ({ title, categories }) => {
  useEffect(() => {
    // Wait for DOM to be ready and Swiper to be available
    const initializeSlider = () => {
      if (!window.Swiper) {
        console.log('Swiper not available yet, retrying...');
        setTimeout(initializeSlider, 100);
        return;
      }

      // Initialize categories slider
      if (
        document.querySelector('.tf-sw-collection') &&
        !document.querySelector('.tf-sw-collection').swiper
      ) {
        console.log('Initializing categories slider...');
        const collectionElement = document.querySelector('.tf-sw-collection');
        const preview = collectionElement.dataset.preview || 4;
        const tablet = collectionElement.dataset.tablet || 2;
        const mobile = collectionElement.dataset.mobile || 2;
        const spacingLg = collectionElement.dataset.spaceLg || 30;
        const spacingMd = collectionElement.dataset.spaceMd || 30;
        const spacing = collectionElement.dataset.space || 15;
        const loop = collectionElement.dataset.loop === 'true';
        const play = collectionElement.dataset.autoPlay === 'true';

        new window.Swiper('.tf-sw-collection', {
          autoplay: play
            ? {
                delay: 2000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }
            : false,
          slidesPerView: mobile,
          loop: loop,
          spaceBetween: spacing,
          speed: 1000,
          pagination: {
            el: '.sw-pagination-collection',
            clickable: true,
          },
          slidesPerGroup: 1,
          navigation: {
            clickable: true,
            nextEl: '.nav-prev-collection',
            prevEl: '.nav-next-collection',
          },
          breakpoints: {
            768: {
              slidesPerView: tablet,
              spaceBetween: spacingMd,
              slidesPerGroup: 2,
            },
            1150: {
              slidesPerView: preview,
              spaceBetween: spacingLg,
              slidesPerGroup: 2,
            },
          },
        });
        console.log('Categories slider initialized successfully');
      }
    };

    initializeSlider();
  }, []);

  return (
    <section className="flat-spacing-5 pb_0">
      <div className="container">
        <div className="flat-title">
          <span
            className="title wow fadeInUp"
            data-wow-delay="0s"
          >
            {title}
          </span>
        </div>
        <div className="hover-sw-nav">
          <div
            dir="ltr"
            className="swiper tf-sw-collection"
            data-preview="4"
            data-tablet="2"
            data-mobile="2"
            data-space-lg="30"
            data-space-md="30"
            data-space="15"
            data-loop="false"
            data-auto-play="false"
          >
            <div
              id="categories-swiper"
              className="swiper-wrapper"
            >
              {categories.map((category, index) => (
                <div
                  key={index}
                  className="swiper-slide"
                >
                  <div className="collection-item style-2 hover-img">
                    <div className="collection-inner">
                      <a
                        href={category.link}
                        className="collection-image img-style"
                      >
                        <img
                          data-src={category.image}
                          src={category.image}
                          alt={category.name}
                        />
                      </a>
                      <div className="collection-content collection-content-before">
                        <a
                          href={category.link}
                          className="tf-btn collection-title hover-icon fs-15 rounded-full"
                        >
                          <span>{category.name}</span>
                          <i className="icon icon-arrow1-top-left"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="nav-sw nav-next-slider nav-next-collection box-icon w_46 round">
            <span className="icon icon-arrow-left"></span>
          </div>
          <div className="nav-sw nav-prev-slider nav-prev-collection box-icon w_46 round">
            <span className="icon icon-arrow-right"></span>
          </div>
          <div className="sw-dots style-2 sw-pagination-collection justify-content-center"></div>
        </div>
      </div>
    </section>
  );
};

export default SquareCategoriesSlider;
